import GET_USER from "./getUser";
import LOGIN from "./login";
import LOGOUT from "./logout";

export default {
  GET_USER,
  LOGIN,
  LOGOUT,
};
